import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import paginationFactory from "react-bootstrap-table2-paginator";
// UI Components
import BootstrapTable from "react-bootstrap-table-next"; // https://react-bootstrap-table.github.io/react-bootstrap-table2/storybook/index.html

// Custom Components
import Loader from "../../../components/Loader";
import Header from "./Header";
import { preferenceTableSchema } from "./preferenceTableSchemas";
import PreferenceFilter from "./PreferenceFilter";
import { getPreferenceLookUp } from "../../../state/actions/adminActions";
import { Container, Card, CardBody } from "reactstrap";

const RECORDS_PER_PAGE = "preferenceLookUpPageSize";

const PreferenceLookUp = ({ errors, loading, preferenceLookUpResult, getPreferenceLookUp }) => {
  const [recordsPerPage] = useState(localStorage.getItem(RECORDS_PER_PAGE) || 50);

  const onUserAction = (accountNumber) => {
    getPreferenceLookUp(accountNumber);
  };

  const LoaderSection = () => {
    return loading && <Loader />;
  };

  return (
    <Container fluid className="p-0">
      <Header />
      <PreferenceFilter onUserAction={onUserAction} loading={loading} />
      <LoaderSection />
      {!loading && (
        <>
          <Card>
            <CardBody>
              <BootstrapTable
                bootstrap4
                hover
                classes="table-responsive-md"
                keyField="id"
                data={preferenceLookUpResult || []}
                columns={preferenceTableSchema}
                bordered={false}
                pagination={paginationFactory({
                  sizePerPage: Number(recordsPerPage),
                  sizePerPageList: [5, 10, 25, 50, 75, 100],
                  onSizePerPageChange: (sizePerPage) => {
                    localStorage.setItem(RECORDS_PER_PAGE, sizePerPage);
                  },
                })}
              />
            </CardBody>
          </Card>
        </>
      )}
    </Container>
  );
};

PreferenceLookUp.propTypes = {
  errors: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  preferenceLookUpResult: PropTypes.array.isRequired,
  getPreferenceLookUp: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  errors: state.admin.errors,
  loading: state.admin.loading.preferenceLookUpResult,
  preferenceLookUpResult: state.admin.preferenceLookUpResult,
});

export default connect(mapStateToProps, {
  getPreferenceLookUp,
})(PreferenceLookUp);
